import { PositionsSort } from "@shared/features/portfolio/types.ts";

export const COIN_CARD_COLUMN_SPANS = [9, 8, 7];

const TABS_HEIGHT = 34;
const PADDING = 12;
export const LAYOUT_DISTANCE_FROM_HEADER = TABS_HEIGHT + PADDING * 2;
export const LAYOUT_DISTANCE_FROM_FOOTER_TWO_ROWS =
  LAYOUT_DISTANCE_FROM_HEADER + 44;

export const POSITION_SORT_TO_PATH: Record<PositionsSort, string> = {
  [PositionsSort.SYMBOL]: "symbol",
  [PositionsSort.LEVERAGE]: "leverage",
  [PositionsSort.POSITION_SIZE]: "position_size",
  [PositionsSort.MARGIN]: "margin[2]",
  [PositionsSort.UNREALIZED_PNL]: "unrealized_pnl",
  [PositionsSort.ENTRY_PRICE]: "entry_price",
  [PositionsSort.PRICE]: "usd_price",
  [PositionsSort.LIQUIDATION_PRICE]: "liquidation_price",
  [PositionsSort.CHANGE]: "graph_data.change[0]",
};

export const DEFAULT_PAIRS = ["USDT", "USD", "BTC"];
